import TradePage from './TradePage';
export { TradePage };
export default TradePage;
